import { create } from 'axios'
import { responseProcessor } from '../helpers/ApiUtil'

const API = create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 120000,
    headers: { 'Content-Type': 'application/json' },
})

const setAccessTokenToHeader = (authToken) => {
    API.defaults.headers.common.Authorization = `Bearer ${authToken}`
}

API.interceptors.response.use((response) => {
    response = responseProcessor(response)
    return response
}, async (error) => {
    if (error.code === 'ECONNABORTED') {
        error.response = responseProcessor({ status: 408 })
    } else {
        error.response = responseProcessor(error.response)
    }
    return Promise.reject(error.response)
})

export default {
    API,
    setAccessTokenToHeader,
}